// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import gridApi from './grid-api';
import isDisplayCreditMemoDisabled from './is-display-credit-memo-disabled';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import selectedDealers from './selected-dealers';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import showSelectAll from './show-select-all';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        gridApi,
        isDisplayCreditMemoDisabled,
        report,
        reportIsScrollable,
        selectedDealers,
        showNoResultsFound,
        showSelectAll
    });



// WEBPACK FOOTER //
// ./src/reports/credit-memo/reducers/index.js